@if (type == 'spinner') {
<div class="loader d-flex align-items-center">
  <mat-spinner class="{{align ? align : 'mx-auto'}} {{color ? color : 'segofinance'}}" [diameter]="size ? size : 100"
    [strokeWidth]="stroke ? stroke : 10"></mat-spinner>
</div>
}

@if (type == 'progress-bar') {
<mat-progress-bar mode="indeterminate" class="{{color}}"></mat-progress-bar>
}

@if (type == 'buffer') {
<mat-progress-bar mode="buffer" class="{{color}}"></mat-progress-bar>
}

@if (type == 'text') {
<p
  class="p1-medium progress-text text-{{align ? align : 'center'}}">
  {{text ? text : 'Cargando'}}<span class="dot">.</span><span class="dot">.</span><span class="dot">.</span>
</p>
}

@if (type == 'dots') {
<p
  class="flickering dots loading-text-{{color ? color : 'segofinance'}} text-{{align ? align : 'center'}} font-size-{{size ? size : '60'}} {{customClass}}">
  &#183;&#183;&#183;
</p>
}

@if (type == 'progress-text') {
<div class="mb-3">
  <mat-progress-bar mode="indeterminate" class="{{color}} {{trackColor}}"></mat-progress-bar>
</div>
<p class="progress-text p-display primary-900">{{text ? text : 'Cargando datos'}} <span class="dot">.</span><span
    class="dot">.</span><span class="dot">.</span></p>
}

@if (type == 'login') {
<div id="login" class="text-center">
  <img src="./assets/images/segofinance/segofinance.png" alt="icono-segofinance" class="img-fluid mat-icon-size-54">
  <div class="login-progress-bar mt-3">
    <mat-progress-bar mode="indeterminate" class="{{color}} {{trackColor}}"></mat-progress-bar>
  </div>
</div>
}